export default "__VITE_ASSET__zYh5xN0___"